/* eslint react/jsx-props-no-spreading: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  Image,
  View,
  TouchableOpacity,
} from 'react-native';
import { matchPath } from 'react-router-dom';

// import AppView from '../consumer/AppView';
import AppInfo from '../consumer/AppInfo';
import imageApprove from '../../assets/images/glyphicons-ok-circle.png';
import imageDecline from '../../assets/images/glyphicons-remove-circle.png';

class AppViewWrapper extends React.Component {
  constructor(props, context) {
    super(props, context);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'AppViewWrapper';
  }

  render() {
    const { history, location } = this.props;

    const match = matchPath('/ai-agent-review/:uuid', location.pathname);
    const uuid = match ? match.params.uuid : undefined;

    return (
      <>
        <AppInfo {...this.props} />
        <View
          style={{
            position: 'absolute',
            top: 160,
            right: 40,
            alignContent: 'flex-end',
            justifyContent: 'flex-start',
          }}
        >
          <TouchableOpacity
            onPress={() => (
              history.push(`/appapprove/${uuid}`)
            )}
          >
            <Image style={{ width: 60, height: 60 }} source={imageApprove} />
          </TouchableOpacity>
          <TouchableOpacity
            style={{
              marginTop: 40,
            }}
            onPress={() => (
              history.push(`/appdecline/${uuid}`)
            )}
          >
            <Image style={{ width: 60, height: 60 }} source={imageDecline} />
          </TouchableOpacity>
        </View>
      </>
    );
  }
}

AppViewWrapper.defaultProps = {
};

AppViewWrapper.propTypes = {
  location: ReactRouterPropTypes.location.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
};

export default AppViewWrapper;
